module.exports = __webpack_public_path__ + "media/images/flags/la-a4fe5b5c17c186ce6495d19acdd130f9.svg";